var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgText = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.49992 3L1.49992 2.5H1.99992L9.99992 2.5H10.4999V3V4C10.4999 4.27614 10.2761 4.5 9.99992 4.5C9.72377 4.5 9.49992 4.27614 9.49992 4V3.5L6.49991 3.5V12.5H7.99992C8.27606 12.5 8.49992 12.7239 8.49992 13C8.49992 13.2761 8.27606 13.5 7.99992 13.5H6.00545L5.99991 13.5L5.99438 13.5H3.99992C3.72377 13.5 3.49992 13.2761 3.49992 13C3.49992 12.7239 3.72377 12.5 3.99992 12.5H5.49991V3.5L2.49992 3.5L2.49992 4C2.49992 4.27614 2.27606 4.5 1.99992 4.5C1.72377 4.5 1.49992 4.27614 1.49992 4L1.49992 3ZM8.49991 7V6.5H8.99991L13.9999 6.5H14.4999V7V8C14.4999 8.27614 14.2761 8.5 13.9999 8.5C13.7238 8.5 13.4999 8.27614 13.4999 8V7.5H11.9999V12.5H12.4999C12.7761 12.5 12.9999 12.7239 12.9999 13C12.9999 13.2761 12.7761 13.5 12.4999 13.5H11.5055C11.5036 13.5 11.5018 13.5 11.4999 13.5C11.4981 13.5 11.4962 13.5 11.4943 13.5H10.4999C10.2238 13.5 9.99992 13.2761 9.99992 13C9.99992 12.7239 10.2238 12.5 10.4999 12.5H10.9999V7.5H9.49991L9.49991 8C9.49991 8.27614 9.27605 8.5 8.99991 8.5C8.72377 8.5 8.49991 8.27614 8.49991 8L8.49991 7Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgText);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/text.8b92903ac74d48fdd41c065638f06c6c.svg";